import React from "react";
import { CurrenciesList } from "../components/CurrenciesList";
import { SettingsManagedPanel } from "../components/SettingsManagedPanel";
import { SettingsLayout } from "../layout/SettingsLayout";

/**
 * CurrencyPage — `/settings/currency`.
 *
 * The currencies this organisation can transact in. A setting in the strict
 * sense: nothing here reports what happened, and the list decides what the
 * bank-account, customer and vendor forms are allowed to offer.
 */
export const CurrencyPage: React.FC = () => (
  <SettingsLayout>
    <SettingsManagedPanel
      title="Currency"
      description="The currencies your books can transact in. Enabling one adds it to Zoho Books too."
    >
      <CurrenciesList />
    </SettingsManagedPanel>
  </SettingsLayout>
);
